import { Button, Col, Divider, Row, Space } from "antd";
import { useEffect, useState } from "react";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { useAlert } from "../provider/AlertProvider";

import MyCarOrder from "./MyCarOrder";
import MyOwnCar from "./MyOwnCar";
import MyRent from "./MyRent";

import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

function MyHistory({ user }: { user?: Types.UserDto }) {
    const alert = useAlert();
    const [orders, setOrders] = useState<Array<Types.OrderDto>>();
    const [carOwners, setCarOwners] = useState<Array<Types.CarOwnerDto>>();
    const [rents, setRents] = useState<Array<Types.RentDto>>();
    const [showHistory, setShowHistroy] = useState<string>("차량주문내역");

    useEffect(() => {
        if (!user) return;

        requestGetOrders();
        requestGetOwnCar();
        requestGetMyRents(user?.email);
    }, [user]);

    //get orders
    const requestAxiosGetOrders = async () => {
        const response = await utilAxiosWithAuth().get(Request.ORDER_MINE_URL, {
            params: { email: user?.email },
        });
        return response.data;
    };

    const { loading: loadingGetOrders, error: errorGetOrders, data: resultGetOrders, execute: requestGetOrders } = useAsyncAxios(requestAxiosGetOrders);

    useEffect(() => {
        if (!resultGetOrders) return;

        console.log("orderList", resultGetOrders.orders);
        setOrders(resultGetOrders.orders);
    }, [resultGetOrders]);

    useEffect(() => {
        if (errorGetOrders === null) return;

        alert.setAlert(errorGetOrders.response.data.code, "Error", errorGetOrders.response.data.message);
    }, [errorGetOrders]);

    //get own cars
    const requestAxiosGetOwnCar = async () => {
        const response = await utilAxiosWithAuth().get(Request.OWNER_MINE_URL, {
            params: { email: user?.email },
        });
        return response.data;
    };

    const { loading: loadingGetOwnCar, error: errorGetOwnCar, data: resultGetOwnCar, execute: requestGetOwnCar } = useAsyncAxios(requestAxiosGetOwnCar);

    useEffect(() => {
        if (!resultGetOwnCar) return;

        console.log("carOwners", resultGetOwnCar.carOwners);
        setCarOwners(resultGetOwnCar.carOwners);
    }, [resultGetOwnCar]);

    useEffect(() => {
        if (errorGetOwnCar === null) return;

        alert.setAlert(errorGetOwnCar.response.data.code, "Error", errorGetOwnCar.response.data.message);
    }, [errorGetOwnCar]);

    //get rents
    const requestAxiosGetMyRents = async (email: string) => {
        const response = await utilAxiosWithAuth().get(Request.RENT_ALL_URL, {
            params: { email: email },
        });
        return response.data;
    };

    const { loading: loadingGetMyRents, error: errorGetMyRents, data: resultGetMyRents, execute: requestGetMyRents } = useAsyncAxios(requestAxiosGetMyRents);

    useEffect(() => {
        if (!resultGetMyRents) return;

        console.log("Rents", resultGetMyRents.rents);
        setRents(resultGetMyRents.rents);
    }, [resultGetMyRents]);

    useEffect(() => {
        if (errorGetMyRents === null) return;

        alert.setAlert(errorGetMyRents.response.data.code, "Error", errorGetMyRents.response.data.message);
    }, [errorGetMyRents]);

    return (
        <div>
            <Col span={6}>
                <Divider orientation="left">
                    <span>이용 내역</span>
                </Divider>
            </Col>
            <Space direction="vertical" size={20} style={{ width: "100%" }}>
                <Row gutter={10}>
                    <Col span={8}>
                        <Button
                            onClick={() => setShowHistroy("차량주문내역")}
                            style={{ width: "100%", backgroundColor: showHistory === "차량주문내역" ? "rgba(93, 160, 227, 0.2)" : "" }}
                        >
                            차량 주문 내역
                        </Button>
                    </Col>
                    <Col span={8}>
                        <Button
                            onClick={() => setShowHistroy("보유차량")}
                            style={{ width: "100%", backgroundColor: showHistory === "보유차량" ? "rgba(93, 160, 227, 0.2)" : "" }}
                        >
                            보유차량
                        </Button>
                    </Col>
                    <Col span={8}>
                        <Button
                            onClick={() => setShowHistroy("렌트이용내역")}
                            style={{ width: "100%", backgroundColor: showHistory === "렌트이용내역" ? "rgba(93, 160, 227, 0.2)" : "" }}
                        >
                            렌트 이용 내역
                        </Button>
                    </Col>
                </Row>
                <Row>
                    {showHistory === "차량주문내역" ? (
                        <MyCarOrder myCarOrder={orders} />
                    ) : showHistory === "보유차량" ? (
                        <MyOwnCar ownCar={carOwners} />
                    ) : (
                        <MyRent rents={rents} />
                    )}
                </Row>
            </Space>
        </div>
    );
}

export default MyHistory;
